import { useEffect } from 'react';

const pmStyles = `
.pm-modal .modal-header {
  background: linear-gradient(135deg, #0369a1 0%, #0ea5e9 100%);
  color: #fff;
  border-bottom: none;
  padding: 1rem 1.5rem;
}
.pm-modal .modal-title {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #fff;
}
.pm-modal .btn-close {
  filter: brightness(0) invert(1);
  opacity: 0.85;
}
.pm-modal .modal-footer {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}
.pm-section {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0369a1;
  margin: 1.25rem 0 0.5rem;
  padding-bottom: 0.25rem;
  border-bottom: 2px solid #e0f2fe;
}
.pm-stage-thead th {
  background: #dbeafe !important;
  color: #1e40af !important;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-bottom: 2px solid #bfdbfe !important;
}
.pm-stage-name {
  background: #f0f9ff !important;
  font-weight: 600;
  color: #0369a1;
  font-size: 0.85rem;
}
.pm-stage-dur {
  background: #f0f9ff !important;
  color: #64748b;
  font-size: 0.85rem;
  text-align: center;
}
.pm-comment-card {
  border-left: 3px solid #0ea5e9 !important;
  border-radius: 6px !important;
  padding: 0.6rem 0.85rem !important;
  background: #f8fafc !important;
  border-top: none !important;
  border-right: none !important;
  border-bottom: 1px solid #e2e8f0 !important;
}
.pm-comment-card + .pm-comment-card {
  margin-top: 0.4rem;
}
.pm-file-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 999px;
  padding: 0.2rem 0.75rem;
  font-size: 0.8rem;
  color: #0369a1;
  margin: 0.2rem 0.2rem 0 0;
}
.pm-file-chip a { color: inherit; text-decoration: none; }
.pm-file-chip a:hover { text-decoration: underline; }
.pm-meta-pill {
  font-size: 0.73rem;
  font-weight: 600;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
}
.pm-oa-card {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  padding: 0.5rem 0.85rem;
}
.pm-oa-card + .pm-oa-card {
  margin-top: 0.4rem;
}
.pm-oa-code {
  font-weight: 700;
  color: #0369a1;
  font-size: 0.8rem;
}
.pm-oa-statement {
  font-size: 0.85rem;
  color: #334155;
  margin: 0.15rem 0 0;
}
`;

export function usePMStyles() {
  useEffect(() => {
    if (document.getElementById('pm-modal-styles')) return;
    const tag = document.createElement('style');
    tag.id = 'pm-modal-styles';
    tag.textContent = pmStyles;
    document.head.appendChild(tag);
  }, []);
}
